<header class="header">
  <app-header
    class="w-full"
    (toogleSidebar)="toggleSidebar()"
    [user]="user()"
    [organization]="applicationContextService.getOrganizationFromContext()"
    [homePageUrl]="homePageUrl()"
    [isMobile]="isMobile()"
    [sidebarVisible]="sidebarVisible()"
  ></app-header>
</header>

<div class="layout-wrapper">
  <aside
    class="sidebar"
    [class.-translate-x-full]="!sidebarVisible()"
    [class.translate-x-0]="sidebarVisible()"
  >
    <app-sidebar
      (closeSidebar)="toggleSidebar()"
      [isMobile]="isMobile()"
      [user]="user()"
    ></app-sidebar>
  </aside>

  <div class="main-content">
    <nav aria-label="breadcrumb" class="breadcrumb-wrapper">
      <app-breadcrumb></app-breadcrumb>
    </nav>
    <main class="router-outlet-padding">
      <router-outlet></router-outlet>
    </main>
    <footer class="footer">
      <hr class="custom-hr" />
      <app-footer></app-footer>
    </footer>
  </div>
</div>
<app-spinner></app-spinner>
